import { useTranslation } from 'react-i18next';

export const InvoicePaymentSuccessPage = () => {
  const { t } = useTranslation(['invoices', 'payments']);

  return (
    <div className="mx-auto w-full max-w-screen-xl px-4 lg:px-8">
      <h3 className="mb-3 heading-3">{t('invoices:thanks_for_payment')}</h3>
      <p className="body-2">{t('payments:payment_successful')}</p>
    </div>
  );
};
